import React from "react";
import {Button, Checkbox, Container, Dimmer, Form, Grid, Loader, Message, Modal} from "semantic-ui-react";
import {NavLink} from "react-router-dom";
import ProgressContainer from "../../Progress/ProgressContainer";

const btn = (reportId, message) => {
    let report = null;
    if (reportId){
        report = <NavLink to={`/report/${reportId}`}><Button className={'centered'} color={'blue'}>Go to report</Button></NavLink>;
    }

    if (message){
        if (message.success){
            return (
                <>
                    <Message color='blue'>{message.success}</Message>
                    {report}
                </>
            )
        }
        if (message.error){
            return (
                <>
                    <Message color='red'>{message.error}</Message>
                    {report}
                </>
            )
        }
    }

    return (
        <Dimmer active inverted>
            <Loader inverted>Your request is being processed...</Loader>
        </Dimmer>
    );

};

const validateEmail = (email) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

const Contact = (props) => {
    let disabled = true;
    if(props.userData.userName && validateEmail(props.userData.userMail) && props.userData.privacyAccept){
        disabled = false;
    }

    let currentdate = new Date();

    return (
        <div>
        <div id={'contact'} className={'step-section'}>
            <Grid>
                <Grid.Column padded={'horizontally'}>
                    <Container className={"pre-header"}>
                        <h2>IT Team Cost Calculator</h2>
                        <h4>With Intersog, you get access to <strong>250+</strong> top software developers ready to commit from day one.</h4>
                    </Container>
                    <ProgressContainer/>
                    <Container className={"contact"}>
                        <h3>You are 1 click away from getting your estimate</h3>
                        <Form>
                            <Form.Group widths='equal'>
                                <Form.Input onChange={props.handleChange} target = 'userName' required fluid placeholder='Name' value={props.userData.userName} />
                                <Form.Input onChange={props.handleChange} target = 'userMail' required fluid placeholder='E-Mail' value={props.userData.userMail} />
                                <Form.Input onChange={props.handleChange} target = 'userPhone' required fluid placeholder='Phone number' value={props.userData.userPhone} />
                            </Form.Group>
                            <Form.TextArea onChange={props.handleChange} target = 'userMessage' placeholder='Tell us more about your project...' value={props.userData.userMessage} />
                            <div className={'privacy-checkbox'}>
                            <Form.Field
                                control={Checkbox}
                                target='privacyAccept'
                                value={props.userData.privacyAccept}
                                onChange={ props.handleChange }
                            /> I give my consent to Intersog to process and retain my personal data as set out in the retention section of the <a href="https://intersog.com/privacy-policy/">Privacy Policy</a>.
                            </div>
                        </Form>
                    </Container>
                    <Container className={"navigation"}>
                        <Button className={`intersog-btn left inverse`} onClick={() =>{props.scrollToStep(6);}}>
                            Back
                        </Button>
                        <Modal trigger={<Form.Button disabled={disabled} color='intersog-btn right' onClick={() =>{props.compile()}} content={'Calculate'} />}>
                            <Modal.Content>
                                {btn(props.userData.reportId, props.userData.responseMessage)}
                            </Modal.Content>
                        </Modal>
                    </Container>
                </Grid.Column>
            </Grid>
        </div>
        </div>
    )
};

export default Contact;